import { styled } from '@linaria/react';
import { cssTheme } from '@daedalus/atlas/themes';
const _exp3 = /*#__PURE__*/() => ({
  isLoading
}) => isLoading ? cssTheme.layout.spacing.s600 : 0;
export const SecondaryOfferListWrapper = /*#__PURE__*/styled('ul')({
  name: "SecondaryOfferListWrapper",
  class: "sh2ffau",
  propsAsIs: false,
  vars: {
    "sh2ffau-0": [_exp3()]
  }
});
export const SecondaryOfferListItem = /*#__PURE__*/styled('li')({
  name: "SecondaryOfferListItem",
  class: "s1vmoo7b",
  propsAsIs: false
});

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");